import { createFileRoute } from '@tanstack/react-router';
import CreateGood from '../../../features/baseData/goods/good/create';
import {
  createPermissionGuard,
  getPermissionSet,
  GOODS_PERMISSIONS,
} from '@bmwe/ui';

export const Route = createFileRoute('/stammdaten/gueter/neu')({
  component: CreateGood,
  beforeLoad: createPermissionGuard(
    getPermissionSet(GOODS_PERMISSIONS, 'EDIT'),
  ),
});

export const CreateGoodRoute = Route;
